// Authentication utilities

// In-memory token storage
let accessToken: string | null = null;
let refreshToken: string | null = null;

/**
 * Store tokens in memory
 */
export function storeTokens(
  accessTokenValue: string,
  refreshTokenValue: string
): void {
  accessToken = accessTokenValue;
  refreshToken = refreshTokenValue;
}

/**
 * Get stored access token from memory
 */
export function getAccessToken(): string | null {
  return accessToken;
}

/**
 * Get stored refresh token from memory
 */
export function getRefreshToken(): string | null {
  return refreshToken;
}

/**
 * Clear stored tokens from memory
 */
export function clearTokens(): void {
  accessToken = null;
  refreshToken = null;
}

/**
 * Check if user is authenticated (has access token)
 */
export function isAuthenticated(): boolean {
  return accessToken !== null;
}
